import {css} from "@emotion/react";

import {HEADER_CELL_WIDTH, HEADER_CELL_WIDTH_MOBILE} from "../constants/table_sizes";

export const cellWidth = css`
    width: calc((1520px - ${HEADER_CELL_WIDTH}) / 7.5);
    min-width: calc((1520px - ${HEADER_CELL_WIDTH}) / 7.5);
`;

export const cellWidthXl = css`
    width: calc((1520px - ${HEADER_CELL_WIDTH}) / 7.5);
    min-width: calc((1520px - ${HEADER_CELL_WIDTH}) / 7.5);
`;

export const cellWidthMd = css`
    width: calc((100vw - ${HEADER_CELL_WIDTH}) / 3);
    min-width: calc((100vw - ${HEADER_CELL_WIDTH}) / 3);
`;

export const cellWidthSm = css`
    width: calc((100vw - ${HEADER_CELL_WIDTH_MOBILE}) / 1.5);
    min-width: calc((100vw - ${HEADER_CELL_WIDTH_MOBILE}) / 1.5);
`;

export const cellWidthPrint = css`
    width: 176px;
    min-width: 176px;
`;
import {css} from "@emotion/react";

import {HEADER_CELL_WIDTH, HEADER_CELL_WIDTH_MOBILE} from "../constants/table_sizes";

export const cellWidth = css`
    width: calc((1520px - ${HEADER_CELL_WIDTH}) / 7.5);
    min-width: calc((1520px - ${HEADER_CELL_WIDTH}) / 7.5);
`;

export const cellWidthXl = css`
    width: calc((1520px - ${HEADER_CELL_WIDTH}) / 7.5);
    min-width: calc((1520px - ${HEADER_CELL_WIDTH}) / 7.5);
`;

export const cellWidthMd = css`
    width: calc((100vw - ${HEADER_CELL_WIDTH}) / 3);
    min-width: calc((100vw - ${HEADER_CELL_WIDTH}) / 3);
`;

export const cellWidthSm = css`
    width: calc((100vw - ${HEADER_CELL_WIDTH_MOBILE}) / 1.5);
    min-width: calc((100vw - ${HEADER_CELL_WIDTH_MOBILE}) / 1.5);
`;

export const cellWidthPrint = css`
    width: 176px;
    min-width: 176px;
`;
